<template>
  <div class="device-detail-usage-details">
    <div class="sheet-info box">
      <ul class="box">
        <template v-for="func in deviceInfo.supportFunc.split(',')">
          <!-- 手工 v-if="deviceInfo.productBrand === 'ICE'-->
          <template v-if="func === 'manual'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_usage_details.ren_gong_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2  :title="$t('dms_device_detail_usage_details.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_usage_details.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.manualUsageTime === 0 ? '-' : $formatSecToHm(info.manualUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_usage_details.qing_jie_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.manualCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.manualCleanArea))| formatThousandth }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.qing_jie_ci_shu')">
                  {{ $t('dms_device_detail_usage_details.qing_jie_ci_shu') }}
                  </h2>
                  <p>{{ info.manualUsageCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 智能清洁 v-if="deviceInfo.productBrand === 'SBR'-->
          <template v-else-if="func === 'autonomous'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_usage_details.zi_zhu_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_usage_details.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.autonomousUsageTime === 0 ? '-' : $formatSecToHm(info.autonomousUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2  :title="$t('dms_device_detail_usage_details.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_usage_details.qing_jie_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.autonomousCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.autonomousCleanArea))| formatThousandth }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.fu_zhu_ci_shu')">
                    {{ $t('dms_device_detail_usage_details.fu_zhu_ci_shu') }}
                  </h2>
                  <p>{{ info.assistCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 教学  v-if="deviceInfo.productBrand === 'SBR'-->
          <template v-else-if="func === 'training'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_usage_details.jiao_xue') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.jiao_xue_shi_changhm')">
                    {{ $t('dms_device_detail_usage_details.jiao_xue_shi_changhm') }}
                  </h2>
                  <p>{{ info.trainingUsageTime === 0 ? '-' : $formatSecToHm(info.trainingUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.jiao_xue_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_usage_details.jiao_xue_mian_ji') }}{{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.trainingCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.trainingCleanArea))| formatThousandth }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 开机 -->
          <template v-else-if="func === 'boot'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_usage_details.kai_ji') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.kai_ji_shi_changhm')">
                    {{$t('dms_device_detail_usage_details.kai_ji_shi_changhm')}}
                  </h2>
                  <p>{{ info.bootTime === 0 ? '-' : $formatSecToHm(info.bootTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.kai_ji_ci_shu')">
                    {{$t('dms_device_detail_usage_details.kai_ji_ci_shu')}}
                  </h2>
                  <p>{{ info.bootCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 充电 v-if="deviceInfo.productBrand === 'ICE'"-->
          <template v-else-if="func === 'charging'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_usage_details.chong_dian') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_usage_details.cdschm')">
                    {{ $t('dms_device_detail_usage_details.cdschm') }}
                  </h2>
                  <p>{{ info.chargingTime === 0 ? '-' : $formatSecToHm(info.chargingTime) }}</p>
                </li>
              </ul>
            </li>
          </template>
        </template>
      </ul>
    </div>

    <div class="data-detail">
      <!-- <div class="header">
        <div class="title">
          {{ $t('page_content_boot_card_use_details1 }}
        </div>
        <el-button
          size="mini"
          class="export"
          type="primary"
          @click="exportPath"
          >{{ $t('com_export_data }}</el-button
        >
      </div> -->
      <div class="search-hd card-search">
        <el-form :inline="true" @submit.native.prevent>
          <!-- <el-form-item>
            <p class="titel">
              {{ $t('page_content_boot_card_use_details1 }}
            </p>
          </el-form-item> -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button class="table-set" style="vertical-align: top" @click="exportPath">
              <i class="icon icon-daochu"></i>
            </el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <!-- 定位码 -->
          <el-form-item :label="$t('dms_device_detail_usage_details.ka_hao')">
            <el-input v-model="formSearch.bootCardNum" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_device_detail_usage_details.mo_shi')">
            <custom-select v-model="formSearch.workClass" code="iot_tsl_use_type2" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
          </el-form-item>
          <!-- 使用人 -->
          <el-form-item :label="$t('dms_device_detail_usage_details.chi_ka_ren')">
            <el-input v-model="formSearch.bootCardOwner" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table :data="tableList" :index="true" @sort="sortChange" @filter="filterChange" @column="setColumn"
          v-if="isInch"
          tableCode="device_sheet_usage_details_ft"
         :slots="['cleanedArea','runLength']"
        >
        <template v-slot:cleanedArea="scope">
            <span>{{$formatLenLocal(scope.row.cleanedArea)| formatThousandth}}</span>
          </template>
          <template v-slot:runLength="scope">
            <span>{{$formatLenLocal(scope.row.runLength,true)}}</span>
          </template>
        </custom-table>
        <custom-table :data="tableList" :index="true" @sort="sortChange" @filter="filterChange" @column="setColumn"
          v-else
          tableCode="device_sheet_usage_details"
        >
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import moment from 'moment';

export default {
  props: {
    usageTimer: [Object, Array],
    deviceInfo: [Object, Array],
    isCharging: {
      type: Boolean,
      default: false,
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    isAutonomous: {
      type: Boolean,
      default: false,
    },
    isTraining: {
      type: Boolean,
      default: false,
    },
    isBoot: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  watch: {
    usageTimer() {
      // 这里特殊 要用报表的偏移时间去调接口reportOffset
      this.formSearch.startTime = this.usageTimer && this.usageTimer[0]
        ? moment
          .utc(this.$momentElLocal(this.usageTimer[0]))
          .utcOffset(this.deviceInfo.utcReportOffset || 0)
          .format('YYYY-MM-DD HH:mm:ss')
        : undefined;
      this.formSearch.endTime = this.usageTimer && this.usageTimer[1]
        ? moment
          .utc(this.$momentElLocal(this.usageTimer[1]))
          .utcOffset(this.deviceInfo.utcReportOffset || 0)
          .format('YYYY-MM-DD HH:mm:ss')
        : undefined;
      this.formSearch.bodyNum = this.deviceInfo.bodyNum;
      // this.getSiteCount();
      this.getSheetInfo();
      this.getTableList();
      // this.getSiteList();
    },
  },
  data() {
    return {
      // tableCode: 'device_sheet_usage_details',
      info: {
        // ICE
        chargingTime: '', // 充电时长
        manualUsageTime: '', // 手工清洁时间
        manualCleanArea: '', // 手工清洁面积
        manualUsageCount: '', // 手工清洁次数
        lastDataUploadedTime: '', // 最后清洁时间
        // SBR
        // 手工清洁时长 h:m ,
        // 手工清洁面积 m²,
        autonomousUsageTime: '', // 智能清洁时长 h:m',
        autonomousCleanArea: '', // 智能清洁面积 m²',
        assistCount: '', // 辅助次数,
        trainingUsageTime: '', // 教学时长 h:m,
        trainingCleanArea: '', // 教学面积 m²,
        totalUsageCount: '', // 清洁次数,
        bootTime: '', // 开机时长 h:m,
        bootCount: '', // 开机次数,
      },
      formSearch: {
        pageSize: 20,
        pageNum: 1,
        bodyNum: '',
        startTime: '',
        endTime: '',
        // 筛选
        searchStartTime: '', // 结束时间
        searchEndTime: '', // 结束时间
        bootCardNum: '', // 卡号
        bootCardOwner: '',
      },
      tableList: [],
      totalRows: null,
    };
  },
  methods: {
    // 获取今日详情
    getSheetInfo: function () {
      this.$getJSON(apis.DeviceReportWorkRunCount, this.formSearch).then((res) => {
        // this.info = res.data;
        if (res.data && Object.keys(res.data).length !== 0) {
          this.$setFormatData(this.info, res.data);
        } else {
          this.info.chargingTime = '';
          this.info.manualUsageTime = '';
          this.info.manualRunLength = '';
          this.info.manualCleanArea = '';
          this.info.manualUsageCount = '';
          this.info.autonomousUsageTime = '';
          this.info.autonomousRunLength = '';
          this.info.autonomousCleanArea = '';
          this.info.trainingUsageTime = '';
          this.info.trainingRunLength = '';
          this.info.trainingCleanArea = '';
          this.info.assistCount = '';
          this.info.totalUsageCount = '';
          this.info.bootTime = '';
          this.info.bootCount = '';
        }
      });
    },
    // 获取列表数据
    getTableList() {
      this.$getJSON(apis.DeviceDeviceReportWorkRunPage, this.formSearch).then((res) => {
        const data = res.data.list || [];
        // 如果是充电模式
        data.forEach((i) => {
          if (`${i.workClass}` === '1') {
            i.bootCardNum = '-';
            i.cardColor = '-';
            i.bootCardOwner = '-';
            i.cleanedArea = '-';
            i.runLength = '-';
          }
        });
        this.nullValueToCrossbar(data, ['assistCount']);
        this.tableList = data;
        // this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page = 1, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 导出数据
    exportPath: function () {
      this.$exportFlie(apis.DeviceReportWorkRunExport, { ...this.formSearch, tableCode: this.isInch ? 'device_sheet_usage_details_ft' : 'device_sheet_usage_details' }).then(() => {});
    },
    clearFilter: function () {
      this.formSearch.bootCardNum = ''; // 路径
      this.formSearch.workClass = ''; // 模式
      this.formSearch.bootCardOwner = ''; // 使用人
      this.getTableList();
    },
  },
  mounted() {
    // this.getTableColumn();
    // 这里特殊 要用报表的偏移时间去调接口utcReportOffset
    this.formSearch.startTime = this.usageTimer && this.usageTimer[0]
      ? moment
        .utc(this.$momentElLocal(this.usageTimer[0]))
        .utcOffset(this.deviceInfo.utcReportOffset || 0)
        .format('YYYY-MM-DD HH:mm:ss')
      : undefined;
    this.formSearch.endTime = this.usageTimer && this.usageTimer[1]
      ? moment
        .utc(this.$momentElLocal(this.usageTimer[1]))
        .utcOffset(this.deviceInfo.utcReportOffset || 0)
        .format('YYYY-MM-DD HH:mm:ss')
      : undefined;
    this.formSearch.bodyNum = this.deviceInfo.bodyNum;
    this.getSheetInfo();
    this.getTableList();
  },
};
</script>

<style lang="scss">
.device-detail-usage-details {
  .gutter {
    height: 16px;
    background: #e4ebf2;
  }

  .sheet-info {
    margin-top: 16px;
    .box {
      padding: 0 16px;
      display: flex;
      li.item {
        border-right: 1px solid #e9ebec;
        margin-left: 32px;
        &:first-child {
          margin: 0;
        }
        .mode {
          height: 28px;
          font-size: 15px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
          margin-bottom: 12px;
        }
        ul {
          display: flex;
          .param {
            padding-right: 32px;
            h2 {
              height: 17px;
              font-size: 12px;
              color: rgba(152, 166, 173, 1);
              line-height: 17px;
              margin-bottom: 5px;
              white-space: normal;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            p {
              height: 26px;
              font-size: 22px;
              font-weight: bold;
              color: rgba(57, 70, 104, 1);
              line-height: 26px;
            }
          }
        }

        &:last-of-type {
          border: none;
        }
      }
    }
    .time {
      color: #0d9ae0;
    }
    .box-bottom {
      margin-top: 16px;
      text-align: right;
      height: 17px;
      font-size: 12px;
      color: #6c757d;
      line-height: 17px;
    }
  }
  .data-detail {
    padding: 24px;
    background-color: #fff;
    margin-top: 16px;
    .search-hd {
      padding: 0 0 24px;
    }
    .header {
      overflow: hidden;
      .title {
        float: left;
        line-height: 28px;
        font-weight: bold;
        color: #495057;
        font-size: 14px;
      }
      .export {
        float: right;
      }
    }
  }
  .el-select {
    .el-input__inner {
      border: 0;
    }
  }
  .table-bd {
    // margin-top: 24px;
  }
}
</style>
